import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["countryCode", "display", "hiddenField"];

  connect() {
    // Store the original display value to detect user changes
    this.originalDisplayValue = this.displayTarget.value;
    this.userHasTyped = false;

    // When country changes, only update if user has typed something new
    this.countryCodeTarget.addEventListener("change", () => {
      if (this.userHasTyped) {
        this.updateHidden();
      }
    });

    // Track form submissions - ensure hidden field is up to date
    const form = this.element.closest("form");
    if (form) {
      form.addEventListener("submit", (_e) => {
        // If user changed country but not the display, we still need to update
        if (this.displayTarget.value && !this.userHasTyped) {
          // Check if country has changed from what matches the hidden field
          this.updateHidden();
        }
      });
    }
  }

  updateHidden() {
    const rawValue = this.countryCodeTarget.value;
    // Parse "US|1" format to get phone code (value is "ISO|phone_code")
    const countryCode = rawValue.includes("|") ? rawValue.split("|")[1] : rawValue;
    const phoneNumber = this.displayTarget.value.trim();

    // Mark that user has typed if display value changed
    if (phoneNumber !== this.originalDisplayValue) {
      this.userHasTyped = true;
    }

    if (phoneNumber) {
      // Remove any non-digit characters (including +)
      let cleanNumber = phoneNumber.replace(/[^\d]/g, "");

      // Strip country code prefix if present
      // For US/Canada (+1), national numbers are 10 digits and never start with 0 or 1
      // So if we have 11+ digits starting with 1, strip it
      if (countryCode) {
        // First pass: strip one country code if it looks like it was included
        if (cleanNumber.startsWith(countryCode) && cleanNumber.length > 10) {
          cleanNumber = cleanNumber.substring(countryCode.length);
        }
        // Second pass: for duplicated country codes (e.g., user pasted "113143338922")
        // Only strip again if we still have too many digits
        if (cleanNumber.startsWith(countryCode) && cleanNumber.length > 10) {
          cleanNumber = cleanNumber.substring(countryCode.length);
        }
      }

      const result = `+${countryCode}${cleanNumber}`;
      this.hiddenFieldTarget.value = result;
    } else {
      this.hiddenFieldTarget.value = "";
    }
  }
}
